module.exports = __webpack_public_path__ + "img/Monte_Kope_15.7721fccb.jpg";